import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { ServicePayload, UserServiceSessionDto } from '@nx-frontend/shared/types';

interface GetSessionPayload extends Omit<ServicePayload, 'userId'> {
  sessionId: string;
}

export async function getSession({ sessionId, host }: GetSessionPayload): Promise<UserServiceSessionDto> {
  const response = await axiosClient.get<UserServiceSessionDto>(
    `${assertServiceHost(host)}/v1/sessions/${sessionId}?fetchMagicLinks=true`
  );
  return response.data;
}
